// Synthesized "paper page-flip" sound using Web Audio API.
// No external audio asset required.
let _ctx = null;
function getCtx() {
  if (_ctx) return _ctx;
  try {
    _ctx = new (window.AudioContext || window.webkitAudioContext)();
  } catch {
    _ctx = null;
  }
  return _ctx;
}

export function playPageFlipSound(direction = 'forward') {
  const ctx = getCtx();
  if (!ctx) return;
  // Resume if suspended (iOS Safari)
  try { ctx.resume?.(); } catch (_) { /* ignore */ }

  const duration = 0.35; // seconds
  const sampleRate = ctx.sampleRate;
  const length = Math.floor(sampleRate * duration);
  const buffer = ctx.createBuffer(1, length, sampleRate);
  const data = buffer.getChannelData(0);

  // Whoosh-like noise envelope with quick attack + decay
  for (let i = 0; i < length; i++) {
    const t = i / length; // 0..1
    const env = Math.pow(1 - t, 2.2) * Math.min(1, t * 8); // attack then decay
    // Pink-ish noise via cascaded random
    const n = (Math.random() * 2 - 1) * 0.6 + (Math.random() * 2 - 1) * 0.4;
    data[i] = n * env;
  }

  const src = ctx.createBufferSource();
  src.buffer = buffer;

  // High-pass + band-pass to evoke paper rustle, not white noise
  const hp = ctx.createBiquadFilter();
  hp.type = 'highpass';
  hp.frequency.value = direction === 'backward' ? 600 : 800;

  const bp = ctx.createBiquadFilter();
  bp.type = 'bandpass';
  bp.frequency.value = direction === 'backward' ? 2200 : 2800;
  bp.Q.value = 0.7;

  const gain = ctx.createGain();
  gain.gain.value = 0.4;

  src.connect(hp);
  hp.connect(bp);
  bp.connect(gain);
  gain.connect(ctx.destination);
  src.start();
}
